// extracted by mini-css-extract-plugin
export default {"styleCarrousel":"CarouselGrid_styleCarrousel__N4y6f","imageSmall":"CarouselGrid_imageSmall__9+HLp"};